import { GraphQLError } from "graphql";

export function isVersionMismatchError(error: GraphQLError) {
  if (!error.extensions) {
    return false;
  }

  return error.extensions.code === "APPLICATION_VERSION_MISMATCH";
}
